/* eslint max-len: "off" */
export default {
    label_filter_add: 'Добавить фильтр',
    label_for_start_status_filter: 'Начальный статус/Точка принятия обязательств',
    label_for_end_status_filter: 'Конечный статус',
    label_ignore_saturday_sunday: 'Не учитывать субботу и воскресенье',
    label_only_included_tasks: 'Задачи должны были быть в этих статусах',
    label_for_charts_period: 'Период',
    label_saved_filters: 'Сохраненные фильтры',
    label_confirm_delete_filter: 'Вы уверены что хотите удалить фильтр?',
    label_select_filter: 'Выбрать отчет',
    label_add_new: 'Добавить новый отчет',
    label_save_filter: 'Сохранить отчет',
    label_edit_filter: 'Редактировать отчет "{name}"',
    label_rename_filter: 'Переименовать отчет "{name}"',
    label_query_new: 'Новый запрос',
    label_report_name: 'Название отчета',
    label_question_icon_only_included_tasks: 'Если эта опция отключена, то на графике будут отображены все задачи, подходящие под условия фильтров. Если задача не побывала в "начальном" статусе, то будет использована дата перевода задачи в ближайший предыдущий статус или дата создания задачи (если таких статусов не будет найдено). Если задача не побывала в "конечном статусе", то будет использована дата перевода задачи в ближайший следующий статус или дата закрытия задачи.',
};
